import styled                            from 'styled-components';
import { bgColor, buttonPrimaryBgColor } from 'Public/Css/colors';
import { Layout }                        from 'antd';

export default styled(Layout) `
    position: relative;
    min-height: 100vh;
    background-color: ${bgColor};
    
`;

